import {
	handleActions
} from 'redux-actions';
import Immutable from 'immutable';

const MantenanceOrderListState = Immutable.fromJS({
	orderList: [],
	activePage: 1,
	itemPerPage: 10,
	totalPage: 1,
	searchWord: '',
	allOrderIds: []
});

const maintenanceOrderListReducer = handleActions({
	FIND_MANTENANCE_ORDER_LIST: (state, { payload }) => {
		return state.merge({
			orderList: payload.data.dataTableData,
			activePage: payload.data.activePage,
			totalPage: payload.data.totalPage,
			itemPerPage: payload.data.itemPerPage,
			searchWord: payload.data.searchWord,
		})
	},

	FIND_ALL_MAINTENANCE_ORDERIDS: (state, { payload }) => {
		return state.merge({
			allOrderIds: payload.data
		})
	},

	CHANGE_MAINTENANCE_ACTIVE_PAGE: (state, { payload }) => {
		return state.merge({
			activePage: payload.activePage,
			itemPerPage: payload.itemPerPage
		})
	}

}, MantenanceOrderListState);

export default maintenanceOrderListReducer;


// WEBPACK FOOTER //
// ./src/reducers/maintenanceOrderListReducer.js